export enum EWhiteLabelingClient {
    MINDSHIELD = 'mindshield',
    RIDLEY_CONSULTING = 'ridleyconsulting',
};

export enum EProduct {
    MBTS = 'mbts',
    MCSA = 'mcsa',
};

export enum ECloudManagement {
    MINDSHIELD = 'mindshield',
    CLIENT = 'client',
};

export enum EClientUserRole {
    ADMIN = 'admin',
    MANAGER = 'manager',
};

export enum EEntitlementSource {
    CLIENT = 'client',
    CLIENT_USER = 'client-user',
    SUB_CLIENT = 'sub-client',
    SUB_CLIENT_USER = 'sub-client-user',
    COHORT = 'cohort',
    COHORT_MEMBER = 'cohort-member',
};